import { createReducer } from "@reduxjs/toolkit";
import { retrieveUserList } from "./retrieve-user-list";
import type { UserVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<UserVM[]> = { fetching: "idle", data: [] };

export const retrieveUserListReducer = createReducer<RetrievalState<UserVM[]>>(initialState, builder => {
  builder.addCase(retrieveUserList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveUserList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveUserList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
